export { PaperClip as default } from './PaperClip';
